/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { useSelector, shallowEqual } from 'react-redux';

export const DashboardContext = React.createContext();

export function DashboardProvider({ children }) {
  const user = useSelector(({ auth }) => auth.user, shallowEqual);
  const [dashboards, setDashboards] = useState([]);

  useEffect(() => {
    // Skip dashboard loading in local mode if flag is set
    if (import.meta.env.VITE_SKIP_DASHBOARD_LOAD === 'true') {
      return;
    }
    getDashboards();
  }, [user]);

  async function getDashboards(token) {
    // Skip dashboard loading in local mode if flag is set
    if (import.meta.env.VITE_SKIP_DASHBOARD_LOAD === 'true') {
      return;
    }
    if ((user || token) && !dashboards.length) {
      const { data } = await axios.get(
        '/dashboards',
        token
          ? {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          : {}
      );
      setDashboards(data);
    }
  }

  return (
    <DashboardContext.Provider value={{ dashboards, getDashboards }}>
      {children}
    </DashboardContext.Provider>
  );
}

export const useDashboards = () => useContext(DashboardContext);
